import htmx from "htmx.org";

// Ensure the global points to the actual htmx instance (ESM default export)
window.htmx = htmx;
